<template>
  <transition name="fade">
    <div>
      <v-form @submit="checkForm">
        <v-text-field
          :rules="rules.required"
          v-model="proveedor"
          label="Nombre"
        ></v-text-field>
        <v-text-field
          :rules="rules.required"
          v-model="rfc"
          label="RFC"
        ></v-text-field>
        <v-autocomplete
          v-model="departamentosAdded"
          :rules="rules.required"
          multiple
          label="Departamento"
          :items="modulos"
        >
        </v-autocomplete>
        <div class="text-right">
          <v-btn  color="success" type="submit">
            Guardar
          </v-btn>
          <v-btn @click="$emit('toggle', false)">
            Cancelar
          </v-btn>
        </div>
      </v-form>
    </div>
  </transition>
</template>

<style>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
export default {
  name: "ProveedorForm",
  components: {},
  props: ["edit", "dataEdit", "loadData"],
  data() {
    return {
      departamentosAdded: [],
      dps: {},
      proveedor: "",
      factura: "",
      rfc: "",
      errors: {},
      loader: true,
      facturas: [],
      Id: null,
      rules: {
        required: [(value) => !!value || "El campo es obligatorio"],
      },
    };
  },
  methods: {
    getDetail(productoId) {
      let producto = this.getProductoById(productoId);
      this.actualExist = producto.Existencia;
      this.nombre = producto.Nombre;
      this.actualPrice = producto.Precio;
      this.newPrice = producto.Precio;
      this.codigo = producto.Codigo;
      this.actualMoneda = producto.Moneda;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.products, { id: code });
      if (itemIndex >= 0) {
        return this.products[itemIndex];
      }

      return false;
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.proveedor) {
        this.errors.proveedor = "El proveedor es obligatorio";
        valid = false;
      } else {
        this.errors.proveedor = false;
      }

      if (!this.rfc) {
        this.errors.rfc = "El rfc es obligatorio";
        valid = false;
      } else {
        this.errors.rfcr = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        } else {
          this.Id = null;
        }
        this.departamentosAdded.forEach((added) => {
          this.dps[added] = true;
        });
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    modulos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    comp_fact() {
      let prod = [
        { id: " ", text: "Seleccione una factura" },
        { id: "535435435", text: "10000 - MR MECHANIC PRO" },
        { id: "535435467", text: "20005 - NIKE" },
        { id: "5354354675", text: "30007 - ADIDAS" },
      ];

      return prod;
    },

    comp_prov() {
      let prod = [
        { id: " ", text: "Seleccione un proveedor" },
        { id: "535435435", text: "MR MECHANIC PRO" },
        { id: "535675", text: "NIKE" },
        { id: "5354455", text: "ADIDAS" },
      ];

      return prod;
    },
  },
  watch: {
    producto: function (val) {
      this.getDetail(val);
    },
  },
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.proveedor = this.dataEdit.nom;
      this.rfc = this.dataEdit.rfc;
      this.Id = this.dataEdit.id;
      let deptos = Object.entries(this.dataEdit.dps);
      deptos.forEach((dpt) => {
        this.departamentosAdded.push(dpt[0]);
      });
    }
  },
};
</script>
